/* eslint-disable camelcase */
import FrameworkUtils from 'utils/framework';
import Message from 'ai/components/SuperChat/Messages/Message/Message';
import { Flex } from 'components/ui';
import FeedbackCollection from 'ai/components/SuperChat/FeedbackCollection';
import LoadingDots from 'ai/components/SuperChat/LoadingDots/LoadingDots';
import { RESPONSE_TYPES, ENTRYPOINTS, MESSAGE_TYPES } from 'ai/constants/superchat';
import ProductRecommendation from 'ai/components/SuperChat/ProductRecommendation';
import RewardCard from 'ai/components/SuperChat/RewardCard';
import ContextualDivider from 'ai/components/SuperChat/ContextualDivider/ContextualDivider';
import { hasRewardProducts, getRewardType } from 'ai/utils/rewardProducts';

const { wrapFunctionalComponent } = FrameworkUtils;

function renderContextualDivider(message, index) {
    const { entrypoint, category, products, search_term } = message.data;

    if (entrypoint === ENTRYPOINTS.PDP && products && products.length > 0) {
        const product = products[0];
        const brandName = product?.brand_name;
        const title = product?.title;

        let label = '';

        if (brandName && title) {
            label = `${brandName} - ${title}`;
        } else if (brandName) {
            label = brandName;
        } else if (title) {
            label = title;
        }

        if (label) {
            return (
                <ContextualDivider
                    key={`divider-${message.session_id}-${index}`}
                    label={label}
                />
            );
        }
    }

    if (entrypoint === ENTRYPOINTS.SRP && search_term) {
        return (
            <ContextualDivider
                key={`divider-${message.session_id}-${index}`}
                label={search_term}
            />
        );
    }

    if (category && category?.name) {
        return (
            <ContextualDivider
                key={`divider-${message.session_id}-${index}`}
                label={category.name}
                categoryId={category.category_id}
            />
        );
    }

    return null;
}

// Filter out hidden event-type messages (e.g., EVENT_USER_HAS_SIGNED_IN)
const isHiddenEventMessage = message => {
    return message.message_type === MESSAGE_TYPES.USER_QUERY && message.data?.type;
};

function Messages(props) {
    const {
        messages, isLoading, feedbackSteps, sessionId, submitFeedback, onCloseFeedback, isPrevious, onSignIn
    } = props;

    if (!messages.length && !isLoading) {
        return null;
    }

    const visibleMessages = messages.filter(m => !isHiddenEventMessage(m));

    return (
        <Flex
            gap={5}
            flexDirection='column'
            width='100%'
        >
            {visibleMessages.map((message, index) => {
                if (message.response_type === RESPONSE_TYPES.CONTEXTUAL_DIVIDER) {
                    if (!isPrevious) {
                        return null;
                    }

                    return renderContextualDivider(message, index);
                }

                if (message.response_type === RESPONSE_TYPES.FEEDBACK_COLLECTION) {
                    return (
                        <FeedbackCollection
                            key='feedback-collection'
                            feedbackSteps={feedbackSteps}
                            sessionId={sessionId}
                            submitFeedback={submitFeedback}
                            onClose={onCloseFeedback}
                        />
                    );
                }

                if (message.response_type === RESPONSE_TYPES.PRODUCT_RECOMMENDATION_RESPONSE) {
                    const products = message?.data?.products || [];

                    if (hasRewardProducts(products)) {
                        return (
                            <RewardCard
                                key={index}
                                products={products}
                                rewardType={getRewardType(products)}
                                viewOnly={message?.data?.view_only || false}
                            />
                        );
                    }

                    return (
                        <ProductRecommendation
                            key={index}
                            products={products}
                            viewAllUrl={message?.data?.view_all_url || null}
                        />
                    );
                }

                return (
                    <Message
                        key={index}
                        message={message}
                        onSignIn={onSignIn}
                    />
                );
            })}

            {/* Show loading dots when waiting for response */}
            {isLoading && <LoadingDots />}
        </Flex>
    );
}

// const styles = {};

export default wrapFunctionalComponent(Messages, 'Messages');
